var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2168 10.884L8.91427 15.6661C8.77991 15.7642 8.63463 15.8083 8.49289 15.7941C8.35114 15.7798 8.21788 15.7076 8.10635 15.5848C7.99482 15.4619 7.90891 15.2925 7.85718 15.0936C7.80544 14.8947 7.78968 14.6732 7.81145 14.451L8.94344 3.68085C8.96833 3.459 9.02982 3.24555 9.12178 3.06175C9.21374 2.87794 9.33297 2.73018 9.46762 2.63317C9.60226 2.53615 9.74762 2.49327 9.88923 2.50878C10.0308 2.5243 10.1638 2.59766 10.2748 2.72159L15.4453 8.70958C15.5526 8.83545 15.6344 9.0054 15.6828 9.20302C15.7312 9.40065 15.7446 9.61928 15.7216 9.83782C15.6986 10.0564 15.6401 10.2674 15.5517 10.4507C15.4633 10.6339 15.3479 10.7831 15.2168 10.884Z",
    fill: "white",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6416 10.2629L4.33907 15.045C4.20471 15.1431 4.05943 15.1873 3.91769 15.173C3.77595 15.1587 3.64268 15.0865 3.53115 14.9637C3.41963 14.8408 3.33372 14.6715 3.28198 14.4725C3.23024 14.2736 3.21448 14.0521 3.23626 13.8299L4.36824 3.05976C4.39314 2.83791 4.45462 2.62446 4.54658 2.44065C4.63855 2.25685 4.75778 2.10909 4.89242 2.01207C5.02706 1.91506 5.17242 1.87218 5.31403 1.88769C5.45564 1.9032 5.58857 1.97657 5.69959 2.10049L10.8701 8.08849C10.9774 8.21436 11.0592 8.38431 11.1076 8.58193C11.156 8.77955 11.1694 8.99818 11.1464 9.21672C11.1234 9.43526 11.0649 9.64634 10.9765 9.82958C10.8881 10.0128 10.7727 10.162 10.6416 10.2629Z",
    fill: "white",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/upi.e6f55b16b6d7c8cb0df5addb77386620.svg";
export { ForwardRef as ReactComponent };